import * as React from 'react';
import { withRouter } from 'react-router';
import DeliverableTasks from '../deliverable_tasks/DeliverableTasks';

// Project-level Tasks tab — tasks directly on the project (no deliverableId).
const ProjectTasksTabPage = ({ match }) => (
	<div className="border-0 border-t border-solid border-owgray bg-white p-6">
		<DeliverableTasks projectId={match.params.id} />
	</div>
);

export default withRouter(ProjectTasksTabPage);
